interface EffectivePermissionsResponse {
    hasApplicationAccess: boolean;
}

export function getEffectivePermissions(token: string): Promise<{ data: EffectivePermissionsResponse }> {
    const baseUrl = process.env.REACT_APP_BASE_API_URL || 'https://localhost:5001/';
    return invoke(baseUrl, token, { endpoint: `user/effective-permissions` });
}

export class NotFoundError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'NotFoundError';
    }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function invoke(baseUrl: string, token: string, options: any): Promise<{ data: EffectivePermissionsResponse }> {
    const url = `${baseUrl}/${options.endpoint}`;

    const request = fetch(url, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${token}`
        }
    })
        .then(response => {
            if (response.status === 404) {
                throw new NotFoundError(`User not found in application. status: ${response.status}`);
            }
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => ({ data }))
        .catch((error: unknown) => {
            // eslint-disable-next-line no-console
            console.error('REJECTED', url, error);
            throw error;
        });

    return request;
}

